<svelte:head>

    <link rel="stylesheet" type="text/css" href="css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";
    import { fade } from 'svelte/transition';

    import {
        errorReasons,
        register
    } from "../api.svelte";

    import { Dropdown } from "carbon-components-svelte";
    import { sessionId } from "../../utils/store";

    import {
        getLocalSessionId,
        getLocalUserStatus,
        getStatusRoute
    } from "../../utils/session";


    const ERROR_DISAPPEAR_AFTER = 5500;


    const router = getContext('router');

    let fullname = '';
    let company = '';
    let country = 'switzerland';
    let email = '';
    let password = '';

    let formError = false;
    let isLoading = false;
    let errorResetTimer = null;


    onMount(() => {

        let localSessionId = getLocalSessionId();

        if (localSessionId) {

            router.route('/');
            return;

        }

        let localStatus = getLocalUserStatus();

        if (localStatus) {

            router.route(getStatusRoute(localStatus));
        }

    });

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let registerHandler = (e) => {

        if (isLoading) return;

        if (fullname === '' || company === ''
            || email === '' || password === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        let contact = {
            'name': fullname,
            'company': company
        };

        register(email, contact, password).then((registerResult) => {

            isLoading = false;

            if (registerResult['status'] !== 'success') {

                formError = registerResult['reason'];
                startErrorResetTimer();

                return;

            }

            // TODO: Set currency in context?

            sessionId.set(registerResult['sessionid']);
            localStorage.setItem('ksessionid', registerResult['sessionid']);
            localStorage.setItem('kstatus', 'onboarding_plans');
            router.route('/plans');

        });

    };

</script>


<div class="onboarding-text">

    <div class="headline-styler"></div>

    <h2>
        Jetzt 15 Tage kostenlos testen.
    </h2>

    <ul class="keyosh-list">

        <li>
            <b>keyosh</b> bietet Ihnen einen einmaligen Einblick in
            Ihre Bewertungen auf Portalen
            wie TripAdvisor, Google und Facebook.
        </li>

        <li>
            Erkennen Sie Trends und Entwicklungen frühzeitig dank
            der einzigartigen portalübergreifenden Bewertungsanalyse.
        </li>

        <li>
            Testen Sie keyosh 15 Tage lang kostenlos.
        </li>

    </ul>

</div>

<div id="register-container" class="forms-container">

    <img id="logo" src="images/logo.svg" alt="keyosh Logo" />

    <form on:submit|preventDefault={() => registerHandler()} id="registerform" class="forms">

        {#if formError}

            <div transition:fade id="error">

                {errorReasons[formError]}

            </div>

        {/if}

        <input
                bind:value={fullname}
                name="fullame"
                type="text"
                placeholder="Name" />

        <input
                bind:value={company}
                name="company"
                type="text"
                placeholder="Firma" />

        <Dropdown
                class="forms-dropdown"
                bind:selectedId={country}
                items={[
                    { id: "switzerland", text: "Schweiz"},
                    { id: "germany", text: "Deutschland"},
                    { id: "austria", text: "Österreich"}
                ]}
        />

        <input
                bind:value={email}
                name="email"
                type="email"
                placeholder="E-Mail" />

        <input
                bind:value={password}
                name="password"
                type="password"
                placeholder="Passwort" />

        <div class="notice-text">
            Mit der Registrierung stimme ich den
            <a href="https://keyosh.com/termsofservice" target="_blank">Allgemeinen Geschäftsbedingungen</a> zu.
        </div>

        <button
                class={(isLoading) ? 'loading btn' : 'btn'}>

            <span>Jetzt testen</span>
            <img src="images/button-loader.svg" />

        </button>

    </form>

    <div class="misclinks">

        <a href="/login">Schon registriert?</a>

    </div>

</div>


<style>

    .onboarding-text {
        margin-right: 21.66vh;
    }

    img#logo {
        height: 4.26vh;
        margin-bottom: 5.86vh;
    }

    #registerform #error {
        width: 28vh;
        padding: 1.78vh;
        margin-bottom: 2.67vh;
        font-size: 1.8vh;
    }

    #registerform input,
    #registerform button,
    #registerform :global(.forms-dropdown button),
    #registerform :global(.forms-dropdown .bx--list-box__menu) {
        width: 28.6vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    #registerform :global(.forms-dropdown .bx--list-box__menu) {
        margin-bottom: 0;
        top: 5.5vh;
    }

    #registerform :global(.forms-dropdown .bx--list-box__menu-item) {
        margin-bottom: 1vh;
    }

    #registerform :global(.forms-dropdown .bx--list-box__menu-item:last-child) {
        margin-bottom: 0;
    }

    .notice-text {
        max-width: 28.6vh;
        margin-bottom: 2.03vh;
        font-size: 1.48vh;
    }

    #registerform button {
        width: 31.46vh;
        margin-bottom: 0;
    }

    .misclinks {
        margin-top: 4vh;
    }

    .misclinks a {
        font-size: 1.42vh;
    }

    @media screen and (max-width: 1024px) {

        .onboarding-text {
            padding: 6vw;
            margin-right: 0;
        }

        #register-container.forms-container {
            padding: 10vw 6vw;
            margin-bottom: 8vw;
        }

        img#logo {
            height: 12vw;
            margin-bottom: 10vw;
        }

        #registerform #error {
            width: 68vw;
            padding: 4vw;
            margin-bottom: 8vw;
            font-size: 4vw;
        }

        #registerform input,
        #registerform button,
        #registerform :global(.forms-dropdown button),
        #registerform :global(.forms-dropdown .bx--list-box__menu) {
            width: 68vw;
            padding: 4vw;
            margin-bottom: 5vw;
            font-size: 4.5vw;
        }

        #registerform :global(.forms-dropdown .bx--list-box__menu) {
            width: 76vw;
            margin-bottom: 0;
            top: 14vw;
        }

        #registerform :global(.forms-dropdown .bx--list-box__menu-item) {
            margin-bottom: 4vw;
        }

        .notice-text {
            max-width: 76vw;
            margin-bottom: 5vw;
            font-size: 3.5vw;
        }

        #registerform button {
            width: 76vw;
            margin-bottom: 0;
        }

        .misclinks {
            display: none;
        }

    }

</style>
